module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "app-switcher-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "app-context-switcher"
  }, [_c('div', {
    staticClass: "app-context-switcher__inner"
  }, _vm._l((_vm.appHistory), function(preview, index) {
    return _c('app-context-switcher-preview', {
      key: index,
      class: [preview.stackId === _vm.currentStackId ? _vm.activeClasses : ''],
      attrs: {
        "preview": preview,
        "tools": _vm.tools,
        "active": preview.stackId === _vm.currentStackId,
        "id": preview.stackId
      },
      on: {
        "click": function () { return _vm.switchContext(preview); }
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60bf9bf5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppSwitcher.vue
// module id = 451
// module chunks = 1